// extracted by mini-css-extract-plugin
export default {"page":"view_page__nTlUG","tableWrapper":"view_tableWrapper__ljumB","pageHeader":"view_pageHeader__6Sf74","noData":"view_noData__VVzoA"};